import React from "react";
import Icon from "components/AppIcon";
import Input from "components/ui/Input";

const SystemParametersConfig = ({ config, onChange }) => {
  const handleChange = (field, value) => {
    onChange("systemParams", field, value);
  };

  return (
    <div className="space-y-6">
      {/* File Upload Settings */}
      <div className="rounded-xl border p-4 md:p-6" style={{ backgroundColor: "var(--color-card)", borderColor: "var(--color-border)" }}>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ backgroundColor: "rgba(15,118,110,0.1)" }}>
            <Icon name="Upload" size={18} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="font-heading font-700 text-base" style={{ color: "var(--color-foreground)" }}>Límites de Carga de Archivos</h3>
            <p className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>Configuración de tamaños y tipos de archivos permitidos</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Tamaño máximo de archivo (MB)"
            type="number"
            value={config?.maxFileSizeMB}
            onChange={(e) => handleChange("maxFileSizeMB", e?.target?.value)}
            placeholder="500"
            description="Límite por archivo de actualización"
          />
          <Input
            label="Archivos simultáneos máximos"
            type="number"
            value={config?.maxConcurrentUploads}
            onChange={(e) => handleChange("maxConcurrentUploads", e?.target?.value)}
            placeholder="3"
            description="Cargas paralelas permitidas"
          />
          <Input
            label="Tipos de archivo permitidos"
            type="text"
            value={config?.allowedFileTypes}
            onChange={(e) => handleChange("allowedFileTypes", e?.target?.value)}
            placeholder=".zip,.tar.gz,.exe,.msi,.pkg"
            description="Extensiones separadas por coma"
          />
          <Input
            label="Almacenamiento total disponible (GB)"
            type="number"
            value={config?.totalStorageGB}
            onChange={(e) => handleChange("totalStorageGB", e?.target?.value)}
            placeholder="100"
            description="Capacidad máxima del sistema"
          />
        </div>
      </div>
      {/* Audit & Retention */}
      <div className="rounded-xl border p-4 md:p-6" style={{ backgroundColor: "var(--color-card)", borderColor: "var(--color-border)" }}>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ backgroundColor: "rgba(217,119,6,0.12)" }}>
            <Icon name="Archive" size={18} color="var(--color-warning)" />
          </div>
          <div>
            <h3 className="font-heading font-700 text-base" style={{ color: "var(--color-foreground)" }}>Retención de Auditoría</h3>
            <p className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>Períodos de conservación de registros de actividad</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Retención de logs de actividad (días)"
            type="number"
            value={config?.auditRetentionDays}
            onChange={(e) => handleChange("auditRetentionDays", e?.target?.value)}
            placeholder="365"
            description="Conforme a normativa colombiana"
          />
          <Input
            label="Retención de logs de descarga (días)"
            type="number"
            value={config?.downloadLogRetentionDays}
            onChange={(e) => handleChange("downloadLogRetentionDays", e?.target?.value)}
            placeholder="180"
          />
          <Input
            label="Retención de logs de seguridad (días)"
            type="number"
            value={config?.securityLogRetentionDays}
            onChange={(e) => handleChange("securityLogRetentionDays", e?.target?.value)}
            placeholder="730"
            description="Mínimo 2 años recomendado"
          />
          <Input
            label="Frecuencia de limpieza automática"
            type="text"
            value={config?.cleanupSchedule}
            onChange={(e) => handleChange("cleanupSchedule", e?.target?.value)}
            placeholder="Diaria a las 02:00 COT"
            description="Horario de mantenimiento"
          />
        </div>
      </div>
      {/* Colombian NIT Validation */}
      <div className="rounded-xl border p-4 md:p-6" style={{ backgroundColor: "var(--color-card)", borderColor: "var(--color-border)" }}>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ backgroundColor: "rgba(5,150,105,0.1)" }}>
            <Icon name="BadgeCheck" size={18} color="var(--color-success)" />
          </div>
          <div>
            <h3 className="font-heading font-700 text-base" style={{ color: "var(--color-foreground)" }}>Validación NIT Colombiano</h3>
            <p className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>Reglas de validación para NIT y dígito de verificación</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 rounded-lg" style={{ backgroundColor: "var(--color-muted)" }}>
            <p className="text-xs font-caption font-600 mb-1" style={{ color: "var(--color-foreground)" }}>Algoritmo de dígito de verificación</p>
            <p className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>Módulo 11 con factores: 3,7,13,17,19,23,29,37,41,43,47,53,59,67,71</p>
          </div>
          <div className="p-3 rounded-lg" style={{ backgroundColor: "var(--color-muted)" }}>
            <p className="text-xs font-caption font-600 mb-1" style={{ color: "var(--color-foreground)" }}>Formato aceptado</p>
            <p className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>NIT: 9 dígitos + guión + 1 dígito verificador (ej: 900123456-7)</p>
          </div>
        </div>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
          {[
            { key: "strictNITValidation", label: "Validación estricta de dígito verificador" },
            { key: "allowForeignOrgs", label: "Permitir organizaciones extranjeras (sin NIT)" },
          ]?.map(({ key, label }) => (
            <label key={key} className="flex items-center gap-3 cursor-pointer p-3 rounded-lg" style={{ backgroundColor: "var(--color-muted)" }}>
              <div
                className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0 transition-base"
                style={{
                  backgroundColor: config?.[key] ? "var(--color-primary)" : "transparent",
                  border: `2px solid ${config?.[key] ? "var(--color-primary)" : "var(--color-border)"}`,
                }}
                onClick={() => handleChange(key, !config?.[key])}
              >
                {config?.[key] && <Icon name="Check" size={12} color="white" strokeWidth={3} />}
              </div>
              <span className="text-sm font-caption" style={{ color: "var(--color-foreground)" }}>{label}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SystemParametersConfig;